import { useMemo } from 'react';
import { ActivityBookingFlagsModel } from '../../api/activityStatusModels';

export const useHotelIdsFromStatus = (activityStatus: ActivityBookingFlagsModel | undefined) => {
  return useMemo(() => {
    if (!activityStatus) {
      return [];
    }
    if (activityStatus.SelectedHotelId) {
      return [activityStatus.SelectedHotelId];
    }
    if (activityStatus.HotelRateIds && activityStatus.HotelRateIds.length > 0) {
      return activityStatus.HotelRateIds;
    }
    if (activityStatus.PreferredHotelId) {
      return [activityStatus.PreferredHotelId];
    }
    return [];
  }, [activityStatus, activityStatus?.HotelRateIds, activityStatus?.SelectedHotelId, activityStatus?.PreferredHotelId]);
};
